export default __webpack_public_path__ + "static/media/background.aae0e981.png";